import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Box from '../Box'
import Modal from '@ntuctech/devex-tangram/Modal'
import ModalTitle from '@ntuctech/devex-tangram/ModalTitle'
import ModalContent from '@ntuctech/devex-tangram/ModalContent'
import ModalActions from '@ntuctech/devex-tangram/ModalActions'
import ButtonText from '@ntuctech/devex-tangram/Button/ButtonText'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'

const StyledModal = styled(Modal)`
  will-change: height;
  transition: height ease 0.3s;
`

const ConfirmModal = ({
  open,
  title,
  bodyContent,
  primaryText,
  primaryAction,
  secondaryText,
  secondaryAction,
  testId,
  alert,
  loading,
}) => {
  const SecondaryButton = alert ? ButtonContained : ButtonText

  const renderModalContent = () => {
    return (
      <>
        <ModalTitle>{title}</ModalTitle>
        <ModalContent>{bodyContent}</ModalContent>
        <ModalActions>
          {secondaryText && (
            <Box mr={1}>
              <SecondaryButton
                onClick={secondaryAction}
                {...(alert && { color: 'grey' })}
                data-testid={`${testId}-cancel`}
                compact
              >
                {secondaryText}
              </SecondaryButton>
            </Box>
          )}
          {primaryText && (
            <ButtonContained
              {...(alert && { color: 'destructive' })}
              onClick={primaryAction}
              data-testid={`${testId}-ok`}
              compact
              loading={loading}
            >
              {primaryText}
            </ButtonContained>
          )}
        </ModalActions>
      </>
    )
  }

  return (
    <StyledModal data-testid={testId} open={open}>
      {renderModalContent()}
    </StyledModal>
  )
}

ConfirmModal.defaultProps = {
  open: false,
  title: '',
  bodyContent: <></>,
  primaryText: '',
  primaryAction: () => {
    /* This is intentional */
  },
  secondaryText: '',
  secondaryAction: () => {
    /* This is intentional */
  },
  testId: 'confirm-modal',
  alert: false,
  loading: false,
}

ConfirmModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  bodyContent: PropTypes.element,
  primaryText: PropTypes.string,
  primaryAction: PropTypes.func,
  secondaryText: PropTypes.string,
  secondaryAction: PropTypes.func,
  testId: PropTypes.string,
  alert: PropTypes.bool,
  loading: PropTypes.bool,
}

export default ConfirmModal
